<template>
	<!-- лоадер вверху страницы -->
	<div id="global-loader" :class="{ visible: globalLoaderVisible }" />

	<!-- шапка -->
	<AppHeader v-if="showNavbar" />

	<!-- тело приложения: скролл-контейнер во всю ширину окна -->
	<div id="app-body">
		<!-- обёртка контента: ужимается по самому широкому блоку страницы,
		     чтобы шапка/панели вставали по его ширине, а не по ширине окна -->
		<div class="app-content">
			<router-view />
		</div>
	</div>

	<!-- глобальные оверлеи — сиблинги #app-body, вне layout-потока -->
	<FilesOperationsPopup />
	<DialogsContainer />
	<CookiePanel />
</template>

<style lang="scss" src="./App.scss" />

<script lang="ts">

import DialogsContainer 		from "@/core/services/Dialogs/DialogsContainer.vue";
import FilesOperationsPopup from "@/core/services/Files/FilesOperationsPopup/FilesOperationsPopup.vue";
import CookiePanel 					from "@/pages/common/MainPage/components/CookiePanel/CookiePanel.vue";
import AppHeader           from "@/lib/components/AppHeader/AppHeader.vue";
import GlobalLoader        from "@/core/services/GlobalLoader/GlobalLoader";

export default defineComponent({
	name: "App",

	components: {
		CookiePanel,
		DialogsContainer,
		FilesOperationsPopup,
		AppHeader,
	},

	computed: {
		globalLoaderVisible(): boolean {
			return GlobalLoader.isVisible;
		},

    showNavbar(): boolean {
      // Навбар скрыт, пока нет партнёра, либо если роут явно просит спрятать.
      // это понадобилось написать при показе оферты не авторизованному пользователю
      // неавторизованному пользователю нечего показывать в шапке
      if (this.$core.currentPartner?.id === undefined) {
        return false;
      } else if (this.$route.meta?.hideNavbar === true) {
        return false;
      } else {
        return true;
      }
    }
	},

	watch: {
		hideNavbar: {
			immediate: true,
			handler(value: boolean) {
				// #app живёт выше корня Vue-дерева (index.html), поэтому классом управляем императивно
				document.getElementById('app')?.classList.toggle('hide-navbar', value);
			},
		},
	},

	created() {
		this.$core.eventBus.AppReady.once(() => {
			this.hideInitialLoader();
		});
	},

	methods: {
		hideInitialLoader() {
			document.getElementById("initial-loader")?.remove();
		},
	},
});
</script>
